export default class ServerResponse {

    constructor() {
        this.status = 0;
        this.data = null;
        this.message = "";
    }

    /**
     * @type {number}
     */
    status;

    /**
     * @type {*}
     */
    data;

    /**
     * @type {string}
     */
    message;
}